import type { ApiClient } from "../api/client.js";
import { navigate } from "./router.js";
import type { SessionStore } from "./session.js";

/** After the active tenant is gone (deleted or left): switch to another one, or ask to create one. */
export async function moveOffTenant(api: ApiClient, sessions: SessionStore, goneTenantId: string): Promise<void> {
  const session = sessions.get();
  if (session === null) return;
  const remaining = session.tenants.filter((tenant) => tenant.id !== goneTenantId);
  const next = remaining[0];
  if (next === undefined) {
    sessions.set({ ...session, tenants: remaining, active: null });
    navigate("/start", { replace: true });
    return;
  }
  sessions.set(await api.call("authSwitch", { body: { tenantId: next.id } }));
  navigate("/activity", { replace: true });
}
